import React from "react";

const Card = ({ children, className="content p-3" }) => {
  return <div className={className}>{children}</div>;
};

export default Card;
